/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import r from "prop-types";
import { validatePackage as n, useUnstyled as l, classNames as d, uError as m } from "@progress/kendo-react-common";
import { packageMetadata as p } from "./package-metadata.mjs";
const a = (c) => {
  const e = {
    direction: "start",
    ...c
  };
  n(p);
  const s = l(), t = s && s.uError, i = o.useMemo(
    () => d(m.wrapper({
      c: t,
      direction: e.direction
    }), e.className),
    [t, e.direction, e.className]
  );
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      id: e.id,
      role: "alert",
      style: e.style,
      className: i
    },
    e.children
  );
};
a.propTypes = {
  id: r.string,
  direction: r.oneOf(["start", "end"]),
  children: r.oneOfType([
    r.element,
    r.node
  ]),
  style: r.object,
  className: r.string
};
a.displayName = "KendoReactError";
export {
  a as Error
};
